module.exports = (__webpack_require__(24))(0);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/react/index.js from dll-reference lib_core
// module id = 0
// module chunks = 106